import { WA_NUMBER_DISPLAY, waLink, DEFAULT_WA_MSG } from "../data/catalogue";
import { Reveal, WhatsAppIcon } from "./Shared";

const STEPS = [
  {
    n: "01",
    title: "Explore & screenshot",
    desc: "Browse our six catalogues and screenshot the products or sets that capture your intent.",
  },
  {
    n: "02",
    title: "Share on WhatsApp",
    desc: `Send your screenshots to ${WA_NUMBER_DISPLAY} along with the quantity you have in mind.`,
  },
  {
    n: "03",
    title: "Get pricing & mockups",
    desc: "Receive pricing, custom logo mockups and delivery timelines straight from our team.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="scroll-mt-24 bg-espresso text-cream py-20 sm:py-28 relative overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 left-1/4 h-[480px] w-[480px] rounded-full opacity-20"
        style={{ background: "radial-gradient(circle, #C85A44 0%, rgba(200,90,68,0) 70%)" }}
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-peach">
            How it works
          </p>
          <h2 className="mt-4 font-serif font-medium tracking-tight text-4xl sm:text-5xl">
            From screenshot to gift box<span className="text-coral-light">.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.14}>
              <div
                data-testid={`how-step-${i + 1}`}
                className="relative border-t border-cream/15 pt-8"
              >
                <span className="font-serif italic text-6xl text-coral-light/80">{s.n}</span>
                <h3 className="mt-5 font-serif font-semibold text-2xl">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-cream/65">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-20">
          <div className="rounded-[2.5rem] border border-cream/12 bg-cream/[0.04] backdrop-blur px-8 py-12 sm:px-14 text-center">
            <p className="font-display text-3xl sm:text-4xl text-peach">अनुबंध</p>
            <p className="mt-3 font-serif italic text-2xl sm:text-3xl text-cream/90">
              Something caught your eye?
            </p>
            <a
              href={waLink(DEFAULT_WA_MSG)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="how-whatsapp-cta"
              className="mt-8 inline-flex items-center gap-3 rounded-full bg-sage px-8 py-4 text-sm font-semibold text-espresso hover:bg-cream transition-colors duration-300"
            >
              <WhatsAppIcon className="h-4 w-4" />
              Chat on WhatsApp · {WA_NUMBER_DISPLAY}
            </a>
            <p className="mt-4 text-xs text-cream/50">
              or write to us at{" "}
              <a
                href="mailto:anubandhgifting@gmail.com"
                data-testid="how-email-cta"
                className="text-peach underline underline-offset-4 hover:text-cream transition-colors duration-300"
              >
                anubandhgifting@gmail.com
              </a>
              <span className="mx-2 text-cream/30">·</span>
              follow{" "}
              <a
                href="https://www.instagram.com/anubandh_gifting"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="how-instagram-cta"
                className="text-peach underline underline-offset-4 hover:text-cream transition-colors duration-300"
              >
                @anubandh_gifting
              </a>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
